import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Gérer les nouveautés")
], -1)
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_5 = { class: "flex card-toolbar w-full" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "p-input-icon-left w-10/12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_9 = { class: "flex w-full mt-6" }
const _hoisted_10 = { class: "flex justify-center ml-auto" }
const _hoisted_11 = { class: "card-body pt-0" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "d-flex flex-row" }

import DataTable from "primevue/datatable";
import { ref, onMounted } from 'vue';
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Column from "primevue/column";
import router from "@/router";
import {deleteNews, fetchNews} from "@/_services/homepage/news";
import {INews} from "@/models/homepage/INews";
import swal from "@/_helpers/swal";

export default /*#__PURE__*/_defineComponent({
  __name: 'NewsList',
  setup(__props) {

const news = Array<INews>();
const tableData = ref<Array<INews>>(news);
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const totalRecords = ref<number>(0);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const page = ref<number>(1);
const modeSortable = ref<boolean>(false);
const defaultsSort = {
    fieldLabel: "order[createdAt]",
    fieldValue: "desc",
};
const addLoading = ref(false);

onMounted(async () => {
    await populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
    isLoading.value = true;
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchNews(
        itemsPerPage,
        page,
        criteria,
        sort
    );
    totalRecords.value = totalRecordsDt.value;
    tableData.value = tableDataDt.value;
    isLoading.value = loadingDt.value;
};

async function onPaginate(e) {
    rows.value = e.rows;
    populateDatatable(e.rows, e.page + 1, criteria.value, defaultsSort);
}

const onSort = (e) => {
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, criteria.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
    }
};

const onSearchInputDt = () => {
    if (0 === criteria.value.length || 3 <= criteria.value.length) {
        populateDatatable(
            rows.value,
            page.value,
            "" != criteria.value ? criteria.value : ""
        );
    }
}

const onDelete = (data: INews) => {
    swal
        .confirm("Êtes vous sur de vouloir supprimer ?")
        .then((result) => {
            if (result.isConfirmed) {
                deleteNews(data.uuid).then(() => {
                    swal.success("succés !", "Suppression effectuée avec succès");
                    populateDatatable(
                        rows.value,
                        page.value,
                        "" != criteria.value ? criteria.value : ""
                    );
                });
            }
        });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        label: "Ajouter une nouveauté",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'addNews' }))),
        icon: "pi pi-plus",
        class: "button-add"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        value: tableData.value,
        paginator: true,
        rows: rows.value,
        removableSort: "",
        loading: isLoading.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: [10, 25, 100],
        currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
        onPage: _cache[3] || (_cache[3] = ($event: any) => (onPaginate($event))),
        onSort: _cache[4] || (_cache[4] = ($event: any) => (onSort($event)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_unref(InputText), {
                    type: "text",
                    class: "w-9/12",
                    modelValue: criteria.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria).value = $event)),
                    placeholder: "Rechercher...",
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (onSearchInputDt()), ["enter"]))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", null, "Nombre total de nouveautés : " + _toDisplayString(totalRecords.value), 1)
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun produit ne correspond à votre recherche")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(Column), {
              field: "vignette",
              header: "Miniature"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.imageWeb)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: slotProps.data.imageWeb.url,
                      class: "w-14"
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "position",
              header: "position",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.position), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "action",
              header: "Action"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-pencil",
                    class: "p-edition",
                    style: {"margin-right":"0.5em"},
                    title: "Éditer",
                    onClick: ($event: any) => (_unref(router).push({ name: 'editNews', params: { uuid: slotProps.data.uuid } }))
                  }, null, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-trash",
                    class: "p-button-danger",
                    style: {"margin-right":"0.5em"},
                    title: "supprimer",
                    onClick: ($event: any) => (onDelete(slotProps.data))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "totalRecords", "currentPage"])
    ])
  ], 64))
}
}

})